// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"Iaa-z"};